import { create, StateCreator } from 'zustand'
import { IMedia } from '@dtos/Course'

export interface ICurrentMedia {
  media: IMedia | null
  enrollmentId: number | null
  courseId: number | null
}

interface ICurrentMediaState {
  currentMedia: ICurrentMedia | null
  setCurrentMedia: (currentMedia: ICurrentMedia | null) => void
  resetCurrentMedia: () => void
}

const createCurrentMediaStore: StateCreator<ICurrentMediaState> = (set) => ({
  currentMedia: null,
  setCurrentMedia: (currentMedia: ICurrentMedia | null) =>
    set({ currentMedia }),
  resetCurrentMedia: () => set({ currentMedia: null }),
})

export const useCurrentMediaStore = create<ICurrentMediaState>(
  createCurrentMediaStore,
)
